import { render, staticRenderFns } from "./MessengerPanel.vue?vue&type=template&id=c4ab629e&"
import script from "./MessengerPanel.vue?vue&type=script&lang=js&"
export * from "./MessengerPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports